<template lang="html">
  <div id="video-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="title">Hágalo usted mismo</h2>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 col-video" v-for="(v, vInx) in videos" :key="'vInx-'+vInx">
          <div>
            <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + v.link" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      videos: []
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/hagalo-usted/'+this.$route.params.id)).then((response)=>{
        this.videos = response.data;
      });
    }
  },

  mounted(){
    this.getContent();
  }
}
</script>
